export default "__VITE_ASSET__BY2pkWrZ__"